import type { SmartMorningControlOption } from './SmartMorningLeadersDashboard';

type SmartMorningPeriodResolution = {
  period_label?: string | null;
};

type SmartMorningPeriodResolver = (period: string) => Promise<SmartMorningPeriodResolution>;

const RELATIVE_PERIOD_OPTIONS = [
  { prefix: 'Current Period', value: 'current month' },
  { prefix: 'Prior Period', value: 'last month' },
  { prefix: 'YTD', value: 'YTD' },
];

const formatResolvedPeriodOptionLabel = (prefix: string, periodLabel?: string | null) => {
  const label = String(periodLabel ?? '').trim();
  if (!label) return prefix;
  const fiscalMatch = label.match(/^(.*?)\s*\((FY\d{2,4}\s+P[^)]+)\)$/i);
  if (!fiscalMatch) return `${prefix} (${label})`;
  return `${prefix} (${fiscalMatch[1].trim()} / ${fiscalMatch[2].trim()})`;
};

export const buildSmartMorningPeriodOptions = (): SmartMorningControlOption[] => RELATIVE_PERIOD_OPTIONS.map(
  ({ prefix, value }) => ({ label: prefix, value }),
);

export const buildResolvedSmartMorningPeriodOptions = async (
  resolvePeriod: SmartMorningPeriodResolver,
): Promise<SmartMorningControlOption[]> => Promise.all(
  RELATIVE_PERIOD_OPTIONS.map(async ({ prefix, value }) => {
    try {
      const resolved = await resolvePeriod(value);
      return { label: formatResolvedPeriodOptionLabel(prefix, resolved.period_label), value };
    } catch {
      return { label: prefix, value };
    }
  }),
);
